import { getStringTime, daysFormat, dateFormat } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
const pouringOrder = {
  pouringOrder: {
    name: 'pouringOrder',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm',
      'deviceData'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'pouringOrder/addPouringOrder',
    editFun: 'pouringOrder/editPouringOrder',
    getListFun: 'pouringOrder/getPouringOrderList',
    deleteFun: 'pouringOrder/deletePouringOrder',
    detailPage: [
      {
        buttonName: '新增',
        name: 'pouringOrder',
        type: 'stepForm',
        theme: 'pouringOrder',
        step: 'pouringOrderInfo',
        label: '新增砼浇筑令信息'
      },
      {
        buttonName: '编辑',
        name: 'pouringOrder',
        type: 'stepForm',
        theme: 'pouringOrder',
        step: 'pouringOrderInfo',
        label: '编辑浇筑令信息',
        checkType: 'checkByUid',
        checkFun: 'pouringOrder/getPouringOrderInfo'
      },
      {
        buttonName: '本单申请(m³)',
        name: 'appliedList',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'pouringOrder/getPouringOrderInfo'
      },
      {
        buttonName: '累计签收(m³)',
        name: 'shipmentList',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'pouringOrder/getPouringOrderInfo'
      },
      {
        buttonName: '历史申请记录',
        name: 'appliedList',
        type: 'drawerTable'
      },
      {
        buttonName: '补方',
        name: 'appliedList',
        type: 'dialogForm',
        checkType: 'checkByUid',
        checkFun: 'pouringOrder/getPouringOrderInfo',
        detailData: (params) => {
          return {
            orderUid: params.row && params.row.uid,
            appliedType: '补方',
            remarks: ''
          }
        }
      },
      {
        buttonName: '中止',
        name: 'terminateForm',
        type: 'dialogForm',
        checkType: 'useRowData',
        pageStatus: 'edit'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      strengthGrade: '',
      executeStatus: '',
      period: [],
      startTime: '',
      endTime: '',
      query: ''
    },
    selectData: [
      {
        key: 'strengthGrade',
        label: '强度等级',
        type: 'input'
      },
      {
        key: 'executeStatus',
        label: '执行状态',
        type: 'select',
        options: [
          { value: '待审核', label: '待审核' },
          { value: '待补方审核', label: '待补方审核' },
          { value: '待生产', label: '待生产' },
          { value: '生产中', label: '生产中' },
          { value: '运输中', label: '运输中' },
          { value: '已中止', label: '已中止' },
          { value: '已完成', label: '已完成' }
        ],
        checkByValue: true
      },
      {
        key: 'period',
        label: '完成时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '浇筑令编号/工程名称/浇筑分项名称'
      }
    ],
    rowData: (params) => {
      return params.state.pouringOrder.pouringOrderList.result
    },
    rowTotal: (params) => {
      return params.state.pouringOrder.pouringOrderList.totalSize
    },
    columns: [
      {
        prop: 'pouringOrderCode',
        label: '浇筑令编号',
        width: '180px'
      },
      {
        prop: 'pouringLocation',
        label: '浇筑分项及部位',
        width: '270px',
        overflow: false,
        tooltip: () => {
          return (row) => {
            return { tipValue: row.singleProName }
          }
        }
      },
      {
        prop: 'strengthGrade',
        label: '强度等级',
        width: '120px'
      },
      {
        prop: 'designQuantity',
        label: '设计方量(m³)',
        width: '80px'
      },
      {
        prop: 'timeText',
        label: '计划/完成时间',
        width: '168px',
        className: 'multi-line',
        overflow: false,
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
                '计划 ' +
                (row.plannedPouringTime || '-') +
                '；完成 ' +
                (row.completedTime && row.completedTime !== '/'
                  ? row.completedTime
                  : '-')
            }
          }
        }
      },
      {
        prop: 'currentAppliedQuantity',
        label: '本单申请(m³)',
        drillDown: true,
        isIdeal: () => {
          return (row) => {
            return !row.auditQuantity ? true : false
          }
        },
        tooltip: { tipValue: '点击查看申请单' }
      },
      {
        prop: 'completedQuantity',
        label: '累计签收(m³)',
        drillDown: true,
        tooltip: { tipValue: '点击查看运输单' },
        width: '200px'
      },
      {
        prop: 'executeStatus',
        label: '执行状态',
        width: '90px',
        tag: [
          { label: '待审核', type: 'warning' },
          { label: '待补方审核', type: 'warning' },
          { label: '待生产', type: 'info' },
          { label: '生产中', type: '' },
          { label: '运输中', type: '' },
          { label: '已中止', type: 'danger' },
          { label: '已完成', type: 'success' }
        ]
      },
      {
        label: '操作',
        width: '300px',
        buttons: setTableButtons(['编辑', '删除', '补方', '中止'])
      }
    ],
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      orgName: (params) => {
        return params.orgName
      },
      workType: '混凝土浇筑令',
      pouringOrderCode: 'JZL' + getStringTime(new Date()),
      singleProName: '',
      subprojectName: '',
      subitemUid: '',
      subitemName: '',
      subitemCode: '',
      subitemType: '',
      strengthGrade: '',
      designQuantity: null,
      plannedPouringTime:
        daysFormat(new Date()) + ' ' + dateFormat(new Date(), 1),
      appliedQuantity: null,
      ambientTemperature: null,
      slump: '',
      productionRequirements: '',
      remarks: '',
      appliedType: '初次',
      appliedPerson: (params) => {
        return params.personName || params.userName || ''
      },
      concretePouring: {}
    },
    formRules: (params) => {
      return params.pageStatus === 'add'
        ? {
            pouringOrderCode: [
              {
                required: true,
                message: '浇筑令编号不能为空',
                trigger: 'blur'
              }
            ],
            subitem: [
              {
                required: true,
                message: '浇筑部位不能为空',
                trigger: 'change'
              }
            ],
            strengthGrade: [
              {
                required: true,
                message: '强度等级不能为空',
                trigger: 'change'
              }
            ],
            plannedPouringTime: [
              {
                required: true,
                message: '计划浇筑时间不能为空',
                trigger: 'blur'
              },
              {
                validator: (params) => {
                  return params.validate.validatePlannedPouringTime
                },
                trigger: 'change'
              }
            ],
            historyApplied: [
              {
                validator: (params) => {
                  return params.validate.validateHistoryApplied
                },
                trigger: 'change'
              }
            ],
            appliedQuantity: [
              {
                required: true,
                message: '申请方量不能为空',
                trigger: 'blur'
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d+)?$/g,
                message: '申请方量应大于0',
                trigger: 'blur'
              }
            ]
          }
        : null
    },
    formData: {
      card: '浇筑令信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'pouringOrderCode',
          label: '浇筑令编号',
          type: 'input',
          disabled: true
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'subitem' : null
          },
          label: '浇筑分项',
          type: 'cascader',
          placeholder: '请选择要浇筑部位所属分项工程',
          options: (params) => {
            return params.state.division.subitemList
          },
          filterable: true,
          checkByValue: true,
          showAllLevels: false
        },
        {
          key: (params) => {
            return params.pageStatus !== 'add' ? 'subitemName' : null
          },
          label: '浇筑分项',
          type: 'input',
          disabled: true
        },
        {
          key: 'remarks',
          label: '浇筑部位',
          type: 'input',
          placeholder:
            '请输入具体部位名称，分节段或层级等多批次浇筑时需备注作业批次，如第一层或第一节等'
        },
        {
          key: 'strengthGrade',
          label: '强度等级',
          type: 'select',
          options: (params) => {
            return params.state.division.structureSize.sizes
              ? params.state.division.structureSize.sizes
              : []
          },
          filterable: true,
          disabled: (params) => {
            return params.pageStatus !== 'add' ? true : false
          }
        },
        {
          key: 'designQuantity',
          label: '设计方量',
          placeholder: '根据强度等级选择获取',
          type: 'input',
          disabled: true,
          inputButton: 'm³',
          number: 2
        },
        {
          key: 'historyApplied',
          label: '历史申请',
          placeholder: '根据强度等级选择获取',
          type: 'input',
          disabled: true,
          inputButton: 'm³',
          number: 2,
          check: (params) => {
            return params.pageStatus !== 'add' ? '历史申请记录' : null
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'appliedQuantity' : null
          },
          label: '申请方量',
          type: 'input',
          placeholder: '请输入大于0的数值',
          inputButton: 'm³',
          number: 2,
          inputTip: (params) => {
            return params.formValues ? params.formValues.auditDescription : ''
          }
        },
        {
          key: 'plannedPouringTime',
          label: '计划浇筑时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          inputTip: '默认为当前时间延后1小时开始浇筑'
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'ambientTemperature' : null
          },
          label: '环境温度',
          type: 'input',
          placeholder: '请输入施工作业环境温度',
          inputButton: '℃',
          number: 1
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'slump' : null
          },
          label: '坍落度',
          type: 'input',
          inputButton: 'mm',
          placeholder: '请输入施工坍落度要求范围'
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'productionRequirements' : null
          },
          label: '生产要求',
          type: 'input',
          placeholder: '请输入发车批次、是否连续发车或其他特殊生产要求'
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'appliedRemarks' : null
          },
          label: '备注说明',
          type: 'input',
          placeholder: '申请量超方或特殊情况时备注说明原因或详情'
        }
      ]
    },
    hasPagination: true,
    appliedList: {
      name: 'appliedList',
      title: (params) => {
        return params.step.slice(-4) === 'Info'
          ? '历史申请记录'
          : params.pageStatus === 'edit'
          ? '编辑申请信息'
          : params.pageStatus === 'add'
          ? '补方申请信息'
          : '本单申请列表'
      },
      deleteFun: 'pouringOrder/deleteAppliedInfo',
      addFun: 'pouringOrder/addAppliedInfo',
      editFun: 'pouringOrder/editAppliedInfo',
      getListFun: 'pouringOrder/getPouringOrderInfo',
      getParentFun: 'pouringOrder/getPouringOrderList',
      headButtons: (params) => {
        return params.step.slice(-4) === 'List'
          ? setCheckButtons(['补方'])
          : null
      },
      detailPage: [
        {
          buttonName: '补方',
          name: 'appliedList',
          type: 'dialogForm',
          checkType: 'detailData',
          detailData: (params) => {
            return {
              ...params.state.pouringOrder.pouringOrderInfo,
              orderUid: params.state.pouringOrder.pouringOrderInfo.uid,
              appliedQuantity: null,
              appliedType: '补方',
              ambientTemperature: null,
              slump: '',
              productionRequirements: '',
              remarks: '',
              auditStatus: '',
              auditUser: ''
            }
          }
        },
        {
          buttonName: '编辑',
          name: 'appliedList',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '审核',
          name: 'pouringOrderAudit',
          type: 'stepForm',
          theme: 'pouringOrder',
          step: 'pouringOrderAuditInfo',
          label: (params) => {
            const row = params.currentRow || params.row || {}
            return row.appliedType === '补方' ? '砼浇筑令补方审核' : '砼浇筑令审核'
          },
          pageStatus: 'check',
          checkType: 'detailData',
          detailData: (params) => {
            const order = (params.state.pouringOrder &&
              params.state.pouringOrder.pouringOrderInfo) ||
              {}
            const app = params.currentRow || params.row || {}
            return {
              uid: app.uid,
              orderUid: order.uid || app.orderUid,
              flowUid: '',
              pouringOrderCode: order.pouringOrderCode,
              subitemName: order.subitemName,
              remarks: order.remarks,
              strengthGrade: order.strengthGrade,
              designQuantity: order.designQuantity,
              historyApplied: order.historyApplied,
              plannedPouringTime: order.plannedPouringTime,
              appliedType: app.appliedType,
              appliedQuantity: app.appliedQuantity,
              ambientTemperature: app.ambientTemperature,
              slump: app.slump,
              productionRequirements: app.productionRequirements,
              appliedRemarks: app.remarks || app.appliedRemarks,
              auditRoleName: app.auditUser || ''
            }
          }
        }
      ],
      rowData: (params) => {
        return params.step.slice(-4) === 'List'
          ? params.state.pouringOrder.pouringOrderInfo.appliedList
          : params.state.pouringOrder.historyApplied.list
      },
      columns: (params) => {
        var columns = [
          {
            label: '申请类型',
            prop: 'appliedType',
            tag: [{ label: '补方', type: 'warning' }],
            width: '100px'
          },
          {
            label: '申请时间',
            prop: 'appliedTime',
            width: '160px'
          },
          {
            label: '申请方量(m³)',
            prop: 'appliedQuantity',
            width: '120px'
          },
          {
            label: '申请人',
            prop: 'appliedPerson',
            tooltip: () => {
              return (row) => {
                return { tipValue: row.appliedPhone }
              }
            },
            width: '100px'
          },
          {
            label: '环境温度(℃)',
            prop: 'ambientTemperature',
            width: '120px'
          },
          {
            label: '坍落度(mm)',
            prop: 'slump',
            width: '120px'
          },
          {
            label: '生产要求',
            prop: 'productionRequirements'
          },
          {
            label: '备注',
            prop: 'remarks'
          },
          {
            label: '审核状态',
            prop: 'status',
            tag: [
              { label: '审核拒绝', type: 'danger' },
              { label: '审核通过', type: 'success' }
            ],
            tooltip: () => {
              return (row) => {
                return {
                  tipValue:
                    row.reviewer + '\xa0\xa0' + (row.review ? row.review : '')
                }
              }
            },
            width: '100px'
          }
        ]
        if (params.step.slice(-4) === 'List') {
          columns.push({
            label: '操作',
            buttons: setTableButtons(['编辑', '删除', '审核'])
          })
        }
        return columns
      },
      formParams: {
        orgUid: '',
        orderUid: '',
        pouringLocation: '',
        strengthGrade: '',
        designQuantity: '',
        historyApplied: '',
        subitemType: '',
        audit: null,
        appliedQuantity: null,
        appliedType: '补方',
        ambientTemperature: null,
        slump: '',
        productionRequirements: '',
        remarks: '',
        auditStatus: '',
        auditUser: '',
        appliedPerson: (params) => {
          return params.personName || params.userName || ''
        }
      },
      formRules: {
        appliedQuantity: [
          {
            required: true,
            message: '申请方量不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/g,
            message: '申请方量应大于0',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'pouringLocation',
          label: '浇筑分项部位',
          type: 'input',
          disabled: true,
          span: 24
        },
        {
          key: 'strengthGrade',
          label: '强度等级',
          type: 'input',
          disabled: true
        },
        {
          key: 'designQuantity',
          label: '设计方量',
          type: 'input',
          disabled: true
        },
        {
          key: 'historyApplied',
          label: '历史申请',
          type: 'input',
          disabled: true
        },
        {
          key: 'appliedQuantity',
          label: '申请方量',
          type: 'input',
          placeholder: '请输入数值',
          inputButton: 'm³',
          number: 2
        },
        {
          key: 'ambientTemperature',
          label: '环境温度',
          type: 'input',
          placeholder: '请输入施工作业环境温度',
          inputButton: '℃',
          number: 1
        },
        {
          key: 'slump',
          label: '坍落度',
          type: 'input',
          inputButton: 'mm',
          placeholder: '请输入施工坍落度要求范围'
        },
        {
          key: 'productionRequirements',
          label: '生产要求',
          type: 'input',
          placeholder: '请输入发车或其他特殊生产要求',
          span: 24
        },
        {
          key: 'appliedRemarks',
          label: '备注说明',
          type: 'input',
          placeholder: '请输入超方或补方原因',
          span: 24
        },
        {
          type: 'tag',
          tag: (params) => {
            return params.formValues ? params.formValues.auditDescription : ''
          },
          span: 24
        }
      ]
    },
    approveForm: {
      title: '混凝土申请审核',
      name: 'approveForm',
      approveFun: 'pouringOrder/approveAppliedInfo',
      getParentFun: 'pouringOrder/getPouringOrderList',
      formParams: {
        orderUid: (params) => {
          return params.state.pouringOrder.pouringOrderInfo.uid
        },
        uid: (params) => {
          return params.state.currentRow.appliedList.uid
        },
        auditStatus: '',
        review: ''
      },
      formRules: {
        review: [
          {
            required: (params) => {
              return params.formValues && params.formValues.auditStatus === '0'
            },
            message: '请输入审批意见',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'auditStatus',
          label: '审批状态',
          type: 'select',
          options: [
            { value: '1', label: '审批通过' },
            { value: '0', label: '审批拒绝' }
          ],
          checkByValue: true,
          span: 18
        },
        {
          key: 'review',
          label: '审批意见',
          type: 'input',
          placeholder: '审批拒绝请务必留下审批意见或建议',
          span: 18
        }
      ]
    },
    shipmentList: {
      name: 'shipmentList',
      title: '运输单列表',
      size: '70%',
      cellAlign: 'center',
      getParentFun: 'pouringOrder/getPouringOrderList',
      detailPage: [
        {
          buttonName: '签收',
          name: 'signing',
          type: 'dialogForm',
          checkType: 'useRowData',
          pageStatus: 'edit'
        },
        {
          buttonName: '监控',
          name: 'deviceData',
          type: 'deviceData',
          label: '查看物联监控数据',
          theme: 'pouringOrder',
          step: 'deviceDataInfo',
          checkType: 'checkByKey',
          checkKey: 'carEnterUid',
          checkFun: 'officialCar/getOfficialCarEnterInfo',
          pageStatus: 'current'
        }
      ],
      rowData: (params) => {
        return params.state.pouringOrder.pouringOrderInfo.shipmentList
      },
      columns: [
        {
          label: '业务车次',
          prop: 'trainNumber',
          width: '80px'
        },
        {
          label: '运输单编号',
          prop: 'shipmentNum',
          width: '180px'
        },
        {
          label: '运输车牌号',
          prop: 'carCode'
        },
        {
          label: '驾驶员',
          prop: 'driverName',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.driverPhone }
            }
          }
        },
        {
          label: '供方名称',
          prop: 'supplierName',
          tooltip: () => {
            return (row) => {
              return {
                tipValue:
                  row.supplierResponPerson +
                  '\xa0\xa0' +
                  row.supplierResponPhone
              }
            }
          }
        },
        {
          label: '运输方量(m³)',
          prop: 'shipmentQuantity'
        },
        {
          label: '发车时间',
          prop: 'departureTime',
          tooltip: () => {
            return (row) => {
              return {
                tipValue: '装货时间：' + row.loadTime
              }
            }
          },
          width: '180px'
        },
        {
          label: '运输状态',
          prop: 'shipmentStatus',
          tag: (params) => {
            return params.dictionarys.shipmentStatus
          },
          tooltip: () => {
            return (row) => {
              return {
                tipValue:
                  '签收意见：' + row.signingOpinion ? row.signingOpinion : '无'
              }
            }
          }
        },
        {
          label: '签收类型',
          prop: 'signingType',
          tag: (params) => {
            return params.dictionarys.signingType
          }
        },
        {
          label: '签收人',
          prop: 'signee',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.signingOpinion }
            }
          }
        },
        {
          label: '签收时间',
          prop: 'signingTime',
          width: '180px'
        },
      {
        label: '操作',
        width: '240px',
        buttons: setTableButtons([
          { name: '监控', code: 'device' },
          { name: '签收', code: 'signing' },
          '二维码'
        ])
      }
    ]
  },
    terminateForm: {
      name: 'terminateForm',
      title: '中止浇筑令',
      editFun: 'pouringOrder/terminatePouringOrder',
      getParentFun: 'pouringOrder/getPouringOrderList',
      formParams: {
        reason: ''
      },
      formRules: {
        reason: [
          {
            required: true,
            message: '请填写中止原因',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'pouringOrderCode',
          label: '浇筑令编号',
          type: 'input',
          disabled: true
        },
        {
          key: 'executeStatus',
          label: '当前执行状态',
          type: 'input',
          disabled: true
        },
        {
          key: 'reason',
          label: '中止原因',
          type: 'input',
          placeholder: '请输入突发无法施工的原因',
          span: 24
        },
        {
          type: 'tag',
          tag: '中止后将短信及系统弹窗通知拌合站生产人员；待审申请自动驳回；待生产任务关闭；有在途或账差的任务进入「已中止待处置」，由拌合站废方或转移处置',
          span: 24
        }
      ]
    },
    signing: {
      name: 'signing',
      title: '运输单签收',
      editFun: 'goodsShipment/editGoodsShipment',
      getParentFun: 'pouringOrder/getPouringOrderInfo',
      formParams: {
        carCode: (params) => params.state.currentRow.shipmentList.carCode,
        trainNumber: (params) =>
          params.state.currentRow.shipmentList.trainNumber,
        approvedQuantity: (params) => {
          const info =
            (params.state.pouringOrder &&
              params.state.pouringOrder.pouringOrderInfo) ||
            {}
          return info.approvedQuantity == null || info.approvedQuantity === ''
            ? 0
            : info.approvedQuantity
        },
        signedQuantity: (params) => {
          const info =
            (params.state.pouringOrder &&
              params.state.pouringOrder.pouringOrderInfo) ||
            {}
          return info.signedQuantity == null || info.signedQuantity === ''
            ? 0
            : info.signedQuantity
        },
        shipmentQuantity: (params) =>
          params.state.currentRow.shipmentList.shipmentQuantity,
        workUid: (params) => params.state.currentRow.shipmentList.workUid,
        shipmentType: (params) =>
          params.state.currentRow.shipmentList.shipmentType,
        signingTime: daysFormat(new Date()) + ' ' + dateFormat(new Date()),
        signingType: '',
        shipmentStatus: '合格签收',
        targetTaskUid: '',
        signingOpinion: '',
        signee: (params) => {
          return params.personName || params.userName || ''
        }
      },
      formRules: {
        shipmentStatus: [
          {
            required: true,
            message: '运输状态不能为空',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateShipmentStatus
            },
            trigger: 'blur'
          }
        ],
        signingType: [
          {
            required: true,
            message: '签收类型不能为空',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateShipmentStatus
            },
            trigger: 'blur'
          }
        ],
        targetTaskUid: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.shipmentStatus === '转移'
              )
            },
            message: '请选择接收转移的同标号生产任务',
            trigger: 'blur'
          }
        ],
        signingTime: [
          {
            required: true,
            message: '签收时间为不能为空',
            trigger: 'blur'
          }
        ],
        signingOpinion: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.shipmentStatus === '不合格签收'
              )
            },
            message: '不合格签收时请填写签收意见',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'carCode',
          label: '运输车牌号',
          type: 'input',
          disabled: true
        },
        {
          key: 'trainNumber',
          label: '业务车次',
          type: 'input',
          disabled: true
        },
        {
          key: 'approvedQuantity',
          label: '累计申请量(m³)',
          type: 'input',
          disabled: true
        },
        {
          key: 'signedQuantity',
          label: '累计合格签收(m³)',
          type: 'input',
          disabled: true
        },
        {
          key: 'shipmentQuantity',
          label: '本车方量(m³)',
          type: 'input',
          disabled: true
        },
        {
          key: 'signingTime',
          label: '签收时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss'
        },
        {
          key: 'shipmentStatus',
          label: '运输状态',
          type: 'select',
          options: [
            { value: '合格签收', label: '合格签收' },
            { value: '不合格签收', label: '不合格签收' }
          ],
          placeholder: '请选择合格签收或不合格签收'
        },
        {
          key: 'signingType',
          label: '签收类型',
          type: 'select',
          options: (params) => {
            const list = params.dictionarys.signingType || []
            if (
              params.formValues &&
              params.formValues.shipmentStatus === '不合格签收'
            ) {
              return list.filter((item) => item && item.value === '中间签收')
            }
            return list
          },
          placeholder: '请选择中间签收或终车签收'
        },
        {
          key: 'targetTaskUid',
          label: '接收任务',
          type: 'select',
          isShow: () => false,
          options: [],
          placeholder: '转移时选择同标号接收生产任务',
          span: 24
        },
        {
          key: 'signingOpinion',
          label: '签收意见',
          type: 'input',
          placeholder:
            '不合格签收请留下原因，合格签收可填下一车混凝土的生产质量意见',
          span: 24
        },
        {
          type: 'tag',
          key: 'signHint',
          tag:
            '不合格签收请留下原因，合格签收可填下一车混凝土的生产质量意见。',
          span: 24
        },
        {
          type: 'tag',
          key: 'finalSignHint',
          tagType: 'danger',
          tag:
            '累计合格签收未达到申请量，如果提交，浇筑令将会按照中止结束，中止原因默认为：已完成浇筑，申请超量。',
          isShow: (params) => {
            const form = params.formValues || {}
            if (form.signingType !== '终车签收') return false
            const info =
              (params.state.pouringOrder &&
                params.state.pouringOrder.pouringOrderInfo) ||
              {}
            const current =
              (params.state.currentRow && params.state.currentRow.shipmentList) ||
              {}
            let signed = Number(info.signedQuantity) || 0
            if (form.shipmentStatus === '合格签收') {
              signed += Number(current.shipmentQuantity) || 0
            }
            const applied = Number(info.approvedQuantity) || 0
            return applied > 0 && signed + 0.01 < applied
          },
          span: 24
        }
      ]
    }
  },
  pouringOrderAudit: {
    name: 'pouringOrderAudit',
    componentTypes: ['navigate', 'stepForm', 'drawerTable'],
    approveFun: 'pouringOrder/approveAppliedInfo',
    getListFun: 'pouringOrder/getPouringOrderList',
    getParentFun: 'pouringOrder/getPouringOrderList',
    detailPage: [
      {
        buttonName: '查看历史申请',
        name: 'appliedList',
        type: 'drawerTable'
      }
    ],
    appliedList: {
      name: 'appliedList',
      title: '历史申请记录',
      cellAlign: 'center',
      rowData: (params) => {
        const hist =
          params.state.pouringOrder && params.state.pouringOrder.historyApplied
        return (hist && hist.list) || []
      },
      columns: [
        {
          label: '申请类型',
          prop: 'appliedType',
          align: 'center',
          tag: [{ label: '补方', type: 'warning' }],
          width: '100px'
        },
        {
          label: '申请时间',
          prop: 'appliedTime',
          align: 'center',
          width: '160px'
        },
        {
          label: '申请方量(m³)',
          prop: 'appliedQuantity',
          align: 'center',
          width: '120px'
        },
        {
          label: '申请人',
          prop: 'appliedPerson',
          align: 'center',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.appliedPhone }
            }
          },
          width: '100px'
        },
        {
          label: '环境温度(℃)',
          prop: 'ambientTemperature',
          align: 'center',
          width: '120px'
        },
        {
          label: '坍落度(mm)',
          prop: 'slump',
          align: 'center',
          width: '120px'
        },
        {
          label: '生产要求',
          prop: 'productionRequirements',
          align: 'center'
        },
        {
          label: '备注',
          prop: 'remarks',
          align: 'center'
        },
        {
          label: '审核状态',
          prop: 'status',
          align: 'center',
          tag: [
            { label: '审核拒绝', type: 'danger' },
            { label: '审核通过', type: 'success' }
          ],
          tooltip: () => {
            return (row) => {
              return {
                tipValue:
                  (row.reviewer || '') +
                  '\xa0\xa0' +
                  (row.review ? row.review : '')
              }
            }
          },
          width: '100px'
        }
      ]
    },
    formParams: {
      uid: '',
      orderUid: '',
      flowUid: '',
      pouringOrderCode: '',
      subitemName: '',
      remarks: '',
      strengthGrade: '',
      designQuantity: null,
      historyApplied: '',
      plannedPouringTime: '',
      appliedType: '',
      appliedQuantity: null,
      ambientTemperature: null,
      slump: '',
      productionRequirements: '',
      appliedRemarks: '',
      auditRoleName: ''
    },
    formData: {
      card: '浇筑令审核',
      submitOnCheck: true,
      bottomButtons: setFormButtons(['同意', '拒绝']),
      fields: [
        {
          key: 'pouringOrderCode',
          label: '浇筑令编号',
          type: 'input',
          disabled: true
        },
        {
          key: 'subitemName',
          label: '浇筑分项',
          type: 'input',
          disabled: true
        },
        {
          key: 'remarks',
          label: '浇筑部位',
          type: 'input',
          disabled: true
        },
        {
          key: 'strengthGrade',
          label: '强度等级',
          type: 'input',
          disabled: true
        },
        {
          key: 'designQuantity',
          label: '设计方量',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'historyApplied',
          label: '历史申请',
          type: 'input',
          disabled: true,
          inputButton: 'm³',
          check: '查看历史申请'
        },
        {
          key: 'plannedPouringTime',
          label: '计划浇筑时间',
          type: 'input',
          disabled: true
        },
        {
          key: 'appliedType',
          label: '申请类型',
          type: 'input',
          disabled: true
        },
        {
          key: 'appliedQuantity',
          label: '本次申请方量',
          type: 'input',
          disabled: true,
          inputButton: 'm³'
        },
        {
          key: 'ambientTemperature',
          label: '环境温度',
          type: 'input',
          disabled: true,
          inputButton: '℃'
        },
        {
          key: 'slump',
          label: '坍落度',
          type: 'input',
          disabled: true,
          inputButton: 'mm'
        },
        {
          key: 'productionRequirements',
          label: '生产要求',
          type: 'input',
          disabled: true,
          span: 24
        },
        {
          key: 'appliedRemarks',
          label: '备注说明',
          type: 'input',
          disabled: true,
          span: 24
        },
        {
          type: 'tag',
          tag: (params) => {
            const form = params.formValues || {}
            const type = form.appliedType === '补方' ? '补方' : '初次'
            return (
              '当前为' +
              type +
              '申请待审，请核对浇筑令及本次申请信息后办理；拒绝须填写审核意见。'
            )
          },
          span: 24
        }
      ]
    }
  },
  deviceData: {
    name: 'deviceData',
    componentTypes: ['navigate', 'deviceData'],
    cardTitle: '物联监控数据信息',
    formTitle: '工程用车信息',
    formData: (params) => {
      var formData = [
        {
          key: 'laborCompanyName',
          label: '所属劳务公司',
          type: 'text'
        },
        {
          key: 'carCode',
          label: '车牌号',
          type: 'text'
        },
        {
          key: 'carModel',
          label: '车辆型号',
          type: 'text'
        },
        {
          key: 'approvedPenson',
          label: '核载人数',
          type: 'text'
        },
        {
          key: 'limitSpeed',
          label: '最大限速(km/h)',
          type: 'text'
        },
        {
          key: 'entryDate',
          label: '进场日期',
          type: 'text'
        },
        {
          key: 'driverName',
          label: '司机姓名',
          type: 'text'
        },
        {
          key: 'driverPhone',
          label: '司机手机号码',
          type: 'text'
        }
      ]
      if (params.pageStatus === 'current') {
        formData.push(
          {
            key: 'ownerName',
            label: '车主姓名',
            type: 'text'
          },
          {
            key: 'ownerPhone',
            label: '车主手机号码',
            type: 'text'
          },
          {
            key: 'carUsage',
            label: '车辆用途',
            type: 'text'
          },
          {
            key: 'stateCn',
            label: '车辆状态',
            type: 'tag'
          },
          {
            key: 'speed',
            label: '速度(km/h)',
            type: 'text'
          },
          {
            key: 'isOverSpeed',
            label: '是否超速',
            type: 'tag'
          },
          {
            key: 'addr',
            label: '当前位置',
            type: 'text'
          }
        )
      } else if (params.pageStatus === 'history') {
        formData.push(
          {
            key: 'mile',
            label: '行驶里程（km）',
            type: 'text'
          },
          {
            key: 'move_long',
            label: '行车时长',
            type: 'text'
          },
          {
            key: 'max_speed',
            label: '最高速度(km/h)',
            type: 'text'
          },
          {
            key: 'avg_speed',
            label: '平均速度(km/h)',
            type: 'text'
          },
          {
            key: 'overspeedNum',
            label: '超速次数',
            type: 'text'
          },
          {
            key: 'stop_long',
            label: '停车时长',
            type: 'text'
          },
          {
            key: 'stopNum',
            label: '停车次数',
            type: 'text'
          }
        )
      }
      return formData
    }
  }
}

export default pouringOrder
